import { onBeforeUnmount, onMounted } from 'vue-demi';

export const useEventBusListener = (
  target: {
      eventBus: {
        $on: (event: string, callback: Function) => void;
        $off: (event: string, callback: Function) => void;
      };
    },
  event: string,
  handler: Function
) => {
  onMounted(() => {
    target.eventBus.$on(event, handler);
  });
  
  onBeforeUnmount(() => {
    target.eventBus.$off(event, handler);
  });
};
  